<div id="footer">
  <p class="footer-text" [innerHTML]="copyrightMsg"></p>
  <span class="img-container">
    <img
      class="logo-style"
      width="84px"
      height="22px"
      src="../../../../assets/icons/danher-digi-logo.png"
      alt="logo"
    />
  </span>
</div>
